import Vue from 'vue';

const state = {
  practices: [],
};

const getters = {

};

const actions = {
  async getPractices({ commit, state }: any) {
    // If not cached and token is avaiable
    if (state.token !== '') {
      try {
        const result: any = await Vue.axios.get(`/api/practices`);
        const { data } = result;
        
        if (data) {
          commit('practices', data);
        }
        
        return data;
      } catch (err) {
        console.error(err);
      }
    } // If cached
    else if (state.practices) {
      return state.practices;
    }
  },
  async createPractice({ commit, state }: any, { name, url, email }: any) {
    if (state.token !== '') {
      try {
        const result: any = await Vue.axios.post(`/api/practices`, {
          name,
          url,
          email 
        });
        const { data } = result;
        
        if (data) {
          commit('addCreatedPractice', data);
        }
        
        return data;
      } catch (err) {
        console.error(err);
      }
    }
  },
  async deletePractice({ commit, state }: any, { practiceId }: any) {
    if (state.token !== '') {
      try {
        const result: any = await Vue.axios.delete(`/api/practices/`+practiceId);
        const { data } = result;
        
        if (data) {
          console.log('delete: ', data);
        }
        
        return data;
      } catch (err) {
        console.error(err);
      }
    }
  },
  async updatePractice({ commit, state }: any, practice: any) {
    if (state.token !== '' && practice.id) {
      try {
        const result: any = await Vue.axios.put(`/api/practices/`+practice.id, {
          ...practice
        });
        const { data } = result;
        
        if (data) {
          console.log('update practice: ', data);
        }
        
        return data;
      } catch (err) {
        console.error(err);
      }
    }
  }
};

const mutations = {
  practices(state: any, practices: any) {
    state.practices = practices;
  },
  addCreatedPractice(state: any, practice: any) {
    state.practices.push(practice);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}